import { openBlock as r, createElementBlock as c, renderSlot as s, createElementVNode as d, normalizeClass as l, normalizeStyle as a, createCommentVNode as f } from "vue";
import { _ as u } from "../_plugin-vue_export-helper-dad06003.js";
const m = {
  name: "rBadgeIcon",
  props: {
    /**
     * 标记位置：left | right
     */
    direction: {
      type: String,
      default: "right"
    },
    /**
     * 图标src
     */
    src: {
      type: String,
      default: ""
    },
    /**
     * 图标宽度（仅对传入src的默认图标有效）
     */
    width: Number,
    /**
     * 图标高度（仅对传入src的默认图标有效）
     */
    height: Number,
    /**
     * 横向偏移值
     */
    offsetX: {
      type: Number,
      default: 5
    },
    /**
     * 纵向偏移值
     */
    offsetY: {
      type: Number,
      default: -5
    }
  },
  computed: {
    iconStyle() {
      const { width: e, height: t } = this;
      return {
        width: e ? `${e}px` : "auto",
        height: t ? `${t}px` : "auto"
      };
    },
    position() {
      return {
        [this.direction === "left" ? "left" : "right"]: `${this.offsetX * -1}px`,
        top: `${this.offsetY}px`
      };
    }
  }
}, h = { class: "r-badge-icon" }, p = ["src"];
function g(e, t, o, _, b, i) {
  return r(), c("div", h, [
    s(e.$slots, "default"),
    d(
      "div",
      {
        class: l(["r-badge-icon--content", `r-badge-icon--content__${o.direction}`]),
        style: a(i.position)
      },
      [
        s(e.$slots, "icon", {}, () => [
          o.src ? (r(), c("img", {
            key: 0,
            src: o.src,
            style: a(i.iconStyle)
          }, null, 12, p)) : f("v-if", !0)
        ])
      ],
      6
      /* CLASS, STYLE */
    )
  ]);
}
const n = /* @__PURE__ */ u(m, [["render", g], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/badge-icon/badge-icon.vue"]]);
n.install = function(e) {
  e.component(n.name, n);
};
export {
  n as default
};
